export const AUCTION_MODULE_PDP = 'auctionModuleDlosPDP';
export const BUY_PERSONALIZED_SEARCH_ITEMS = 'BUY_PERSONALIZED_SEARCH_ITEMS';
